import React from 'react';
import { Outlet } from 'react-router-dom';

import { Container, Conteudo } from './styles';
import Header from '../Header';
import MenuLateral from '../MenuLateral';

// Layout fixo das telas internas (depois do login)
export default function Layout() {
  return (
    <Container>
      <Header />
      <MenuLateral />
      <Conteudo>
        <Outlet />
      </Conteudo>
    </Container>
  );
}
